document.addEventListener('DOMContentLoaded', function () {
  // waveform bars
  document.querySelectorAll('.js-hero-wave').forEach(function (el) {
    for (let i = 0; i < 46; i++) {
      const b = document.createElement('i');
      b.style.animationDelay = (Math.random() * -1.2).toFixed(2) + 's';
      b.style.animationDuration = (0.8 + Math.random() * 0.8).toFixed(2) + 's';
      b.style.height = (12 + Math.random() * 52) + 'px';
      el.appendChild(b);
    }
  });
  document.querySelectorAll('.js-wave').forEach(function (el) {
    for (let i = 0; i < 26; i++) {
      const b = document.createElement('i');
      b.style.animationDelay = (Math.random() * -1.2).toFixed(2) + 's';
      b.style.animationDuration = (0.8 + Math.random() * 0.8).toFixed(2) + 's';
      el.appendChild(b);
    }
  });

  // reveal on scroll
  const io = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  // click-to-play video testimonials
  document.querySelectorAll('.vframe').forEach(function (fr) {
    const src = fr.getAttribute('data-src');
    if (!src) return;
    const type = fr.getAttribute('data-type');
    fr.addEventListener('click', function () {
      if (fr.querySelector('video, iframe')) return;
      let el;
      if (type === 'tiktok') {
        el = document.createElement('iframe');
        el.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        el.allow = 'autoplay; encrypted-media; picture-in-picture; clipboard-write';
        el.allowFullscreen = true;
        el.frameBorder = '0';
      } else {
        el = document.createElement('video');
        el.src = src;
        el.controls = true;
        el.autoplay = true;
        el.playsInline = true;
      }
      fr.appendChild(el);
      const btn = fr.querySelector('.vplay');
      if (btn) btn.style.display = 'none';
    });
  });

  document.querySelectorAll('.reveal').forEach(function (el) {
    io.observe(el);
  });

  // creator application form
  const applyForm = document.getElementById('apply-form');
  if (applyForm) {
    const emailInput = document.getElementById('apply-email');
    const submitBtn = applyForm.querySelector('.js-apply-submit');
    const statusEl = applyForm.querySelector('.js-apply-status');
    const endpoint = applyForm.getAttribute('data-endpoint');
    const submitLabel = submitBtn.textContent;

    const setStatus = function (message, variant) {
      statusEl.textContent = message;
      statusEl.className = 'apply-status js-apply-status' + (variant ? ' apply-status--' + variant : '');
    };

    applyForm.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!endpoint) return;

      const email = emailInput.value.trim();
      if (!email) {
        setStatus('Please enter your email.', 'error');
        return;
      }

      const tokenInput = applyForm.querySelector('[name="cf-turnstile-response"]');
      const turnstileToken = tokenInput ? tokenInput.value : '';
      if (!turnstileToken) {
        setStatus('Please wait a moment for verification to finish, then try again.', 'error');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
      setStatus('', null);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ creatorEmail: email, turnstileToken: turnstileToken }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            throw new Error((result.data && result.data.message) || 'Something went wrong. Please try again.');
          }
          applyForm.reset();
          if (window.turnstile) window.turnstile.reset();
          submitBtn.textContent = 'Request sent';
          setStatus("Thanks! We've got your application and will be in touch.", 'success');
        })
        .catch(function (err) {
          if (window.turnstile) window.turnstile.reset();
          submitBtn.disabled = false;
          submitBtn.textContent = submitLabel;
          setStatus(err.message || 'Something went wrong. Please try again.', 'error');
        });
    });
  }
});
